export default "__VITE_ASSET__D1hxgTf4__"